/* eslint-disable no-console */
import { Logger } from '../../providers/logger.context';
import { LogLevel } from '../types/utils.model';

export class ConsoleLogger implements Logger {
  level: LogLevel = import.meta.env.MODE === 'development' ? LogLevel.DEBUG : LogLevel.INFO;

  info(...msg: unknown[]): void {
    if (this.level > LogLevel.INFO) {
      return;
    }
    console.info('[INFO] ', ...msg);
  }

  warn(...msg: unknown[]): void {
    if (this.level > LogLevel.WARN) {
      return;
    }
    console.warn('[WARN] ', ...msg);
  }

  error(...args: unknown[]): void {
    if (this.level > LogLevel.ERROR) {
      return;
    }

    args.forEach((arg) => {
      const hasDetails = typeof arg === 'object' && arg !== null && 'details' in arg;
      const hasName = typeof arg === 'object' && arg !== null && 'name' in arg;
      const hasMessage = typeof arg === 'object' && arg !== null && 'message' in arg;

      if (hasDetails && hasName && hasMessage) {
        console.error('[ERROR] ' + arg.name + ': ' + arg.message, arg.details);
      } else {
        console.error('[ERROR] ', arg);
      }

      console.error('[ERROR] ', arg);
    });
  }

  stateChange(
    previousState: Record<string, unknown>,
    change: Record<string, unknown>,
    nextState: Record<string, unknown>
  ): void {
    if (this.level > LogLevel.DEBUG) {
      return;
    }

    const keysChanged = Object.keys(change);

    const diff = keysChanged.map((key) => {
      const prev = previousState[`${key}`];
      const next = change[`${key}`];

      return { key, prev, next };
    });

    console.groupCollapsed(`%c[STATE UPDATE] ${keysChanged.join(', ')}`, 'color: #CCC');
    console.table(diff, ['key', 'prev', 'next']);
    console.log('%cSTATE:', 'color: cyan', { ...nextState });
    console.count('UPDATES');
    console.trace('%cCALL STACK: ', 'color: cyan');
    console.groupEnd();
  }
}
